module.exports = __webpack_public_path__ + "img/DIHS_Logo_neg_rgb_600px_oc.4b37b34b.png";